import { Box, Theme, withStyles } from '@material-ui/core';
import { grey } from 'globals/colors';
import FsBody from 'ui-elements/typography/FsBody';

export const TagContainer = withStyles(({ spacing }: Theme) => ({
  root: {
    padding: spacing(0.5, 1),
    margin: spacing(0.5, 0.5),
    backgroundColor: grey.V4,
    borderRadius: spacing(1),
    cursor: 'pointer',
  },
}))(Box);

export const TagText = withStyles(() => ({
  root: {
    color: grey.V2,
    fontSize: 24,
    textTransform: 'capitalize',
  },
}))(FsBody);
